import React, { useCallback } from 'react';

import Slider from 'react-slick';

import { Box } from '@vp/swan';
import { useLocalizations } from '@vp/ubik-localizations-provider';

import { sendMediaEngaged } from '../../../../infrastructure/clients/trackingClient';
import { Slide } from '../../domain/Slide';
import { SlideArray } from '../../domain/SlideArray';

import { ThumbnailsCarousel } from './ThumbnailsCarousel';
import { buildThumbnailSlide } from './thumbnailsSlideFactory';

export interface ThumbnailsProps {
  nav: Slider | undefined;
  setNav: (value: Slider | undefined) => void;
  slideArray: SlideArray;
  setCurrentSlide: (value: number) => void;
  infinite: boolean;
  mpvId: string;
  productKey: string;
}

export const Thumbnails: React.FC<ThumbnailsProps> = (props: ThumbnailsProps) => {
  const { t } = useLocalizations();

  const handleThumbnailClick = useCallback(
    (position: number): void => {
      sendMediaEngaged(position, props.mpvId, props.productKey);
      props.setCurrentSlide(position - 1);
    },
    [sendMediaEngaged, props.setCurrentSlide]
  );

  return (
    <Box>
      <Box style={{ width: `${props.slideArray.widthPercentage}%` }}>
        <ThumbnailsCarousel
          className="thumbnails"
          asNavFor={props.nav}
          ref={(slider) => props.setNav(slider ?? undefined)}
          slidesToScroll={1}
          slidesToShow={props.slideArray.slidesToShow}
          dots={false}
          swipeToSlide={true}
          focusOnSelect={true}
          infinite={props.infinite}
          arrows={true}
          accessibleTextForNext={t('next')}
          accessibleTextForPrevious={t('previous')}
          progressIndicator="none"
          gridGutters={true}
          gridGuttersVariant={'tight'}
          aria-label={t('thumbnails-container-label')}
        >
          {props.slideArray.all.map((slide: Slide) =>
            buildThumbnailSlide(slide, handleThumbnailClick)
          )}
        </ThumbnailsCarousel>
      </Box>
    </Box>
  );
};
